import { render, staticRenderFns } from "./StatementEditForm.vue?vue&type=template&id=66323572&"
import script from "./StatementEditForm.vue?vue&type=script&lang=js&"
export * from "./StatementEditForm.vue?vue&type=script&lang=js&"
import style0 from "./StatementEditForm.vue?vue&type=style&index=0&id=66323572&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports